/**
 * One tap from the landing page into a game: Welcome asks for it when "Play now" creates a guest, and Home
 * starts the game as soon as it can (the tutorial at once, the arena once the lobby is connected).
 * Kept in sessionStorage so it survives the switch from the signed-out to the signed-in screens, and no longer.
 */
const KEY = 'snakefeast.autoplay';

export function requestAutoPlay(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* storage blocked: the player just lands on Home */
  }
}

/** True once, if a game was asked for: reading it clears it. */
export function takeAutoPlay(): boolean {
  try {
    if (sessionStorage.getItem(KEY) !== '1') return false;
    sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}

export function hasAutoPlay(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
